
const IndiaFlag = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="17" viewBox="0 0 23 17" fill="none">
  <rect x="0.75" y="0.75" width="21.5" height="15.5" rx="1.75" fill="white" stroke="#F5F5F5" strokeWidth="0.5"/>
  <mask id="mask0_1325_7478" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="23" height="17">
    <rect x="0.75" y="0.75" width="21.5" height="15.5" rx="1.75" fill="white" stroke="white" strokeWidth="0.5"/>
  </mask>
  <g mask="url(#mask0_1325_7478)">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.5 5.83333H22.5V0.5H0.5V5.83333Z" fill="#FFA44A"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M0.5 16.4998H22.5V11.1665H0.5V16.4998Z" fill="#1A9F0B"/>
    <path d="M11.5 6.56689C12.5575 6.56689 13.4051 7.43763 13.4053 8.49951C13.4053 9.56157 12.5576 10.4331 11.5 10.4331C10.4425 10.433 9.5957 9.56153 9.5957 8.49951C9.59591 7.43767 10.4426 6.56697 11.5 6.56689Z" fill="#181A93" fill-opacity="0.15" stroke="#181A93" strokeWidth="0.666667"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M11.4999 9.03346C11.7892 9.03346 12.0237 8.79468 12.0237 8.50013C12.0237 8.20558 11.7892 7.9668 11.4999 7.9668C11.2106 7.9668 10.9761 8.20558 10.9761 8.50013C10.9761 8.79468 11.2106 9.03346 11.4999 9.03346Z" fill="#181A93"/>
  </g>
</svg>
  )
}

export default IndiaFlag